<template>
  <div>
    <div v-for="(c, i) in list" :key="c.Id" class="card_item" @click="goLabItem(c)">
      <div class="collegePic">
        <img :src="c.photo ? '/mainsys/UserFiles/labPhoto/' + c.photo : c.picture" width="100%" height="100%" />
      </div>
      <div class="collegeInfo">
        <div class="collegeTitle">{{c.orgName}}</div>
        <div class="collegeRoom">
          <span>开放: {{c.labOpenCount}}/{{c.labCount}}间</span>
        </div>
        <div class="collegeStatus" :class="{open: c.labOpenCount > 0, close: c.labOpenCount === 0 }">
          <span v-if="c.labOpenCount > 0 ">已开放</span>
          <span v-else>未开放</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Toast } from "vant";
export default {
    props: {
      list: {
        list: Array,
        default: []
      },
    },
    data(){
      return {}
    },
    methods: {
      goLabItem(college){
        if(!college.labOpenCount) {
          Toast('实验室暂未开放')
          return;
        }
        this.$router.push({
          path: 'labList',
          name: '',
          query: { 
            name: college.orgName 
          }
        })
      }
    },
    mounted() {
        
    }
}
</script>
<style scoped>
  .collegePic {
    width: 70px;
    height:70px;
  }
  .collegePic img {
    width: 100%;
    height: 100%;
  }
  .collegeInfo {
    position: relative;
    width: calc(100% - 85px);
    height: 70px;
    margin-left: 15px;
  }
  .collegeInfo .collegeTitle {
    font-size: 16px;
  }
  .collegeInfo .collegeRoom {
    position: absolute;
    bottom: 0;
    left:0px;
    display: flex;
  }
  .collegeInfo .collegeStatus {
    position: absolute;
    top: 0px;
    right: -10px;
    padding: 3px 6px;
    color: #fff;
    font-size: 12px;
  }
  .collegeInfo .collegeStatus.open {
    background-color: #329977;
  }
  .collegeInfo .collegeStatus.close {
    background-color: #ea9090;
  }
  .card_item {
    display: flex;
    width: 100%;
    box-shadow: 0 1px 4px 0 #00000014;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    padding:15px;
  }
</style>